import {factoryQuestion} from "../../ClassTypeQuestions/facetoryQuestion";
import {validateAnswer}  from "../../sevicesInRecord";

const setDisableQuestionNotAnswers = (flowedQuestions, questions) => {
    const questionsDisable = questions.map(question => {
        return {
            ...question,
            visibility: true,
        }
    });
    flowedQuestions.forEach(question => {
        questionsDisable[question.index] = {
            ...questionsDisable[question.index],
            answers: question.answers,
            visibility: false
        }
    });
    return questionsDisable;
};

// const  isQuestionMessage = (question) => {
//     return question.getType() === 'Message';
// };


const setEnableQuestionWhenLoadDraft = (flowedQuestions, questions) => {
    const questionsDisable = questions.map(question => {
        return {
            ...question,
            visibility: true,
        }
    });
    flowedQuestions.forEach(question => {
        questionsDisable[question.index] = {
            ...questionsDisable[question.index],
            answers: question.answers,
            visibility: false
        }
    });
    const endFlowQuestions = flowedQuestions[flowedQuestions.length - 1];
    if(validateAnswer(endFlowQuestions) && endFlowQuestions.index + 1 > questions.length) {
        questionsDisable[endFlowQuestions.index + 1] = {
            ...questionsDisable[endFlowQuestions.index + 1],
            visibility: false
        };
    }
    return questionsDisable;
};

class CreatorLogicEditRecord {

    constructor(questions, flow = []) {
        if(flow.length) {
            this.flow = flow.map(question => {return { ...question, visibility: false}});
            const questionEnd = this.flow[this.flow.length-1];
            if(validateAnswer(questionEnd)) {
               const indexQuestionNext =  factoryQuestion(questionEnd).getNext(validateAnswer(questionEnd));
               if(indexQuestionNext < questions.length) {
                   this.flow.push({
                        ...questions[indexQuestionNext],
                        visibility: false
                    })
               }
            }
            const questionsNew = setEnableQuestionWhenLoadDraft(this.flow, questions);
            this.questions = questionsNew.map(questionData => factoryQuestion(questionData));
        }else {
            this.questions = questions.map(questionData => factoryQuestion(questionData));
        }
    }


    // setDisableQuestion(questionEdited, nextQuestionEdited) {
    //     const indexQuestions = questionEdited.getIndex();
    //
    //     if(nextQuestionEdited - indexQuestions > 1 ){
    //         for (let i = indexQuestions; i < nextQuestionEdited; i++) {
    //             this.questions[i + 1].disable();
    //         }
    //     }
    //
    //     for (let i = this.questions.length-1; i > nextQuestionEdited; i--) {
    //         this.questions[i].disable();
    //     }
    //
    //     const indexOfQuestionNext = questionEdited.getNext(questionEdited.getAnswer());
    //
    //     if(indexOfQuestionNext >= this.questions.length) {
    //         throw new Error(`not index of question continue or of out list question`);
    //     }
    //
    //     const questionContinue = this.questions[indexOfQuestionNext];
    //
    //     if(validateAnswer(questionContinue.toJSON())) {
    //         this.updateAnswerQuestion(questionContinue.getIndex(), questionContinue.getAnswer())
    //     }
    //
    //     this.questions[nextQuestionEdited].enable();
    // }


    // updateAnswerQuestion(questionIndex, answer) {
    //     let questionEdited    = this.questions[questionIndex];
    //     let nextQuestionEdited  = questionEdited.answer(answer);
    //     if(nextQuestionEdited < this.questions.length) {
    //         if(isQuestionMessage(this.questions[nextQuestionEdited]) &&
    //             nextQuestionEdited !== this.questions.length - 1) {
    //             this.questions[nextQuestionEdited].enable();
    //             questionEdited      = this.questions[nextQuestionEdited];
    //             nextQuestionEdited  = this.questions[nextQuestionEdited].getNext();
    //         }
    //
    //         if (questionEdited.getIndex() + 1 < this.questions.length) {
    //             this.setDisableQuestion(questionEdited, nextQuestionEdited);
    //         }
    //
    //     }
    //     return this.questions[questionIndex];
    // }

    updateAnswerQuestion(questionIndex, answer) {
        let questionEdited     = this.questions[questionIndex];
        let nextQuestionEdited = questionEdited.answer(answer);

        if (nextQuestionEdited >= this.questions.length) {
            return this.questions[questionIndex];
        }

        for (let i = nextQuestionEdited; i < this.questions.length; i++) {
            this.questions[i].enable();
        }
        // disable cac cau trong break
        for (let i = questionIndex + 1; i < nextQuestionEdited; i++) {
            this.questions[i].disable();
        }

        //check answer to update and check out loop
        this.questions.forEach(question => {

            if (validateAnswer(question.toJSON()) && !question.isDisabled()) {
                let indexNextQuestion = question.getNextQuestion();

                if (question.getType() === 'YesNo') {
                    indexNextQuestion = question.answer(question.getAnswer());
                }

                if (question.getType() === 'Single') {
                    if (typeof question.getNextQuestion() === 'number') {
                        indexNextQuestion = question.getNextQuestion();
                    } else {
                        indexNextQuestion = question.answer(question.getAnswer());
                    }
                }

                if (question.getType() !== 'Single' && question.getType() !== 'YesNo' && typeof question.getNextQuestion() === 'number') {
                    indexNextQuestion = question.getNextQuestion();
                }

                for (let i = indexNextQuestion; i < this.questions.length; i++) {
                    this.questions[i].enable();
                }
                if(indexNextQuestion < this.questions.length) {
                    for (let i = question.getIndex() + 1; i < indexNextQuestion; i++) {
                        this.questions[i].disable();
                    }
                    this.questions[indexNextQuestion].enable();
                }
            }
        });
        // enable cau tiep theo
        this.questions[nextQuestionEdited].enable();

        if (validateAnswer(this.questions[nextQuestionEdited].toJSON()) && nextQuestionEdited > questionIndex) {
            let questionEdited = this.questions[nextQuestionEdited];
            this.updateAnswerQuestion(questionEdited.getIndex(), questionEdited.getAnswer());
        }
    }



    toRecord() {
        const questions = this.questions.map(question => question.toJSON());
        return questions.filter(question => !question.visibility)
    }


    getQuestions() {
        const questions = this.questions.map(question => question.toJSON());
        return setDisableQuestionNotAnswers(this.toRecord(), questions);
    }

    toDraft() {
        return {
            flow     : this.toRecord(),
            questions: this.questions.map(question => question.toJSON()),
        }
    }

    static fromDraft(draftData) {
        return new CreatorLogicEditRecord(draftData.questions, draftData.flow)
    }


}

export default CreatorLogicEditRecord;

// const questions = [{"type":"InputText","content":"input text","heading":"1","index":0,"nextQuestion":1,"answers":"trtr et","disable":false},{"type":"YesNo","content":"yesNo ?","heading":"","index":1,"nextQuestion":"","nextQuestionNo":3,"nextQuestionYes":2,"answers":"No","disable":false},{"type":"YesNo","content":"Yes ?","heading":"","index":2,"nextQuestion":4,"nextQuestionNo":"","nextQuestionYes":"","answers":"","hasPrevious":true,"disable":true},{"type":"InputText","content":"No ?","heading":"","index":3,"nextQuestion":4,"answers":"er ter t","hasPrevious":true,"disable":false},{"type":"Date","content":"date ","heading":"","index":4,"nextQuestion":5,"answers":1555520400,"disable":false},{"type":"Single","choices":[{"answer":"12","nextQuestion":6},{"answer":"13","nextQuestion":7},{"answer":"14","nextQuestion":8},{"answer":"15","nextQuestion":9},{"answer":"16","nextQuestion":10},{"answer":"17","nextQuestion":6}],"content":"single select ?","heading":"","index":5,"answers":{"answer":"16","nextQuestion":10,"is_choice":4},"disable":false},{"type":"InputText","content":"12","heading":"","index":6,"nextQuestion":8,"answers":"","disable":true},{"type":"InputText","content":"13","heading":"","index":7,"answers":"","disable":true},{"type":"InputText","content":"14","heading":"","index":8,"answers":"","disable":true},{"type":"InputText","content":"15","heading":"","index":9,"answers":"","disable":true},{"type":"InputText","content":"16","heading":"","index":10,"answers":"16","disable":false},{"type":"InputText","content":"17","heading":"","index":11,"answers":"3453 4","disable":false},{"type":"MultiChoice","choices":[{"answer":"1122"},{"answer":"12"},{"answer":"13"}],"content":"multichoice co next vao next muchoice2","heading":"","index":12,"nextQuestion":14,"answers":[{"answer":"1122","is_choice":false},{"answer":"12","is_choice":true},{"answer":"13","is_choice":false}],"disable":false},{"type":"InputText","content":"next muchoice1","heading":"","index":13,"answers":"","disable":true},{"type":"InputText","content":"next muchoice2","heading":"","index":14,"answers":"34 34 ","disable":false},{"type":"Media","content":"meadia co next vao media 2","heading":"","index":15,"nextQuestion":17,"answers":{"answer":"https://static-survey-recording-dev.s3.ap-northeast-1.amazonaws.com/2019/04/16/8793569b-f1ac-49d5-a44a-431ef1da27e9.png","typeAnswer":"image/png"},"disable":false},{"type":"Media","content":"media 1","heading":"","index":16,"answers":{},"disable":true},{"type":"Media","content":"media 2","heading":"","index":17,"answers":{"answer":"https://static-survey-recording-dev.s3.ap-northeast-1.amazonaws.com/2019/04/16/bcce3321-0fbe-453b-ab56-47ad0fc055ba.png","typeAnswer":"image/png"},"disable":false},{"type":"Message","content":"message cos next vao message 2","heading":"","index":18,"nextQuestion":20,"disable":false},{"type":"Message","content":"message 1","heading":"","index":19,"disable":true},{"type":"Message","content":"message 2","heading":"","index":20,"answers":"Message","disable":false}];
// const creatorLogicEditRecord = new CreatorLogicEditRecord(questions);
// console.log('11',creatorLogicEditRecord.getQuestions());
// creatorLogicEditRecord.updateAnswerQuestion(1, 'Yes');
// console.log('22',creatorLogicEditRecord.getQuestions());
